import * as React from 'react';

import { Help } from '../../../../../components/Icons';
import { ControlLinkButton } from '../../../../../components/ControlLinkButton';

import * as styles from './styles.css';

interface IHelpLinkButtonProps {
  href: string;
  onClick(): void;
}

export const HelpLinkButton: React.FC<IHelpLinkButtonProps> = ({ href, onClick }) => {
  return (
    <ControlLinkButton
      title="Помощь"
      href={href}
      className={styles['container']}
      target="_blank"
      rel="noreferrer"
      size="XL"
      tooltip="Помощь"
      rounded
      onClick={onClick}
    >
      <Help />
    </ControlLinkButton>
  );
};

HelpLinkButton.displayName = 'HelpLinkButton';
